import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import { ConnectedProps } from 'mf-shared/types/common';
import { resendVerificationEmail } from '../../state/action-mess';
import { setResendEmailVerificationState } from '../../state/moka/actions';
import { setModalRegistration } from '../../state/register/actions';

import AuthTitle from '../Titles/AuthTitle';
import ResendVerificationEmailForm from './ResendVerificationEmailForm';
import NotificationModal from './NotificationModal';

import styles from './style.css';

function mapStateToProps(state) {
  return {
    resendVerificationEmail: state.moka.resendVerificationEmail,
    resetCaptcha: state.registerForm.resetCaptcha,
  };
}

const connector = connect(mapStateToProps);

interface ResendVerificationEmailProps {
  readonly history?: any;
}

interface ResendVerificationEmailState {}

type Props = ConnectedProps<typeof connector, ResendVerificationEmailProps>;

class ResendVerificationEmail extends React.Component<
  Props,
  ResendVerificationEmailState
> {
  render() {
    const { resendVerificationEmail: _resendVerificationEmail } = this.props;

    return (
      <div className={styles.root}>
        <AuthTitle title="Resend Verification Email" />
        <div className={`text-center mb-40px ${styles['text-margin-resend']}`}>
          <p className="no-margin">
            Please enter your email address and we will
          </p>
          <p className="no-margin">re-send you a verification email.</p>
        </div>
        <ResendVerificationEmailForm onSubmit={this.handleSubmit} />

        <NotificationModal
          isShow={_resendVerificationEmail.isModalShow}
          headerMessage={_resendVerificationEmail.headerMessage}
          bodyMessage={_resendVerificationEmail.bodyMessage}
          btnConfirm={'Sign In'}
          btnHide={'Close'}
          onHide={this.onEmailAlreadyRegisteredModalHide}
          onConfirm={this.onEmailAlreadyRegisteredModalConfirm}
          isNotificationError={_resendVerificationEmail.modalStatus}
        />
      </div>
    );
  }

  /**
   * Handle submit from redux from
   * @param values json object contains {email}
   */
  handleSubmit = (values) => {
    const { dispatch, resetCaptcha } = this.props;
    const { email, captcha } = values;

    dispatch(
      resendVerificationEmail({
        oldEmail: email,
        newEmail: email,
        captcha,
        resetCaptcha,
      })
    );
  };

  onEmailAlreadyRegisteredModalConfirm = () => {
    const { dispatch, resendVerificationEmail: _resendVerificationEmail } =
      this.props;

    dispatch(setResendEmailVerificationState({ isModalShow: false }));

    if (_resendVerificationEmail.modalStatus === 'unregistered') {
      dispatch(setModalRegistration(false, {}));
      browserHistory.push('/register');
    } else {
      browserHistory.push('/login');
    }
  };

  onEmailAlreadyRegisteredModalHide = () => {
    const { dispatch } = this.props;

    dispatch(setResendEmailVerificationState({ isModalShow: false }));
  };
}

// Wrap the component to inject dispatch and state into it
export default connector(ResendVerificationEmail);
